import localizedText from '../../../../util/localized-text-with-replacements'

export const REDUCER_NAME = 'quotation'

export const PRODUCT_TYPE_ALIGNERS = 'aligners'
export const PRODUCT_TYPE_IMPLANTS = 'implants'

const QUOTATION_COMMENT_NOT_PERFECT = 'final_result_not_perfect'
const QUOTATION_COMMENT_PZR_REQUIRED = 'pzr_required'
const QUOTATION_COMMENT_PZR_RECOMMENDED = 'pzr_recommended'

const QUOTATION_COMMENT_DURATION_DIFFERS = 'duration_differs'
const QUOTATION_COMMENT_PRETREATMENT = 'pretreatment'


const PACKAGESIZE_LIGHT = 'light'
const PACKAGESIZE_MEDIUM = 'medium'
const PACKAGESIZE_COMPLEX = 'complex'

export const SUPPLIER_ID_KEY_MAP = {
    // for staging
    'df3d945ad5e-016a-052c-46bc809e8ab9': 'hat_group',
    'df3d945ad80-9b5d-447f-49d98b3a4287': 'sunshine_smile',

    // for prod
    'df42ffbd2c7-f030-e185-4b6e9e9af833': 'hat_group',
    'df42ffbd2ec-1c61-6491-4d75802ba516': 'sunshine_smile',
}

export const SUPPLIER_TECHNICAL_NAME_SUNSHINE_SMILE = 'sunshine_smile'
export const SUPPLIER_TECHNICAL_NAME_HAT_GROUP = 'hat_group'

export const getQuotationCommentSelectValues = (isPretreatmentNeeded) =>
    isPretreatmentNeeded ?
        QUOTATION_COMMENT_SELECT_VALUES :
        QUOTATION_COMMENT_SELECT_VALUES_WITHOUT_PRETREATMENT

export const QUOTATION_COMMENT_SELECT_VALUES = [
    {
        id: QUOTATION_COMMENT_NOT_PERFECT,
        value: 'Result not optimal',
    },
    {
        id: QUOTATION_COMMENT_PZR_REQUIRED,
        value: 'PZR required',
    },
    {
        id: QUOTATION_COMMENT_PZR_RECOMMENDED,
        value: 'PZR recommended',
    },
    {
        id: QUOTATION_COMMENT_DURATION_DIFFERS,
        value: 'Duration differs',
    },
    {
        id: QUOTATION_COMMENT_PRETREATMENT,
        value: 'Pretreatment',
    },
]

export const QUOTATION_COMMENT_SELECT_VALUES_WITHOUT_PRETREATMENT = [
    {
        id: QUOTATION_COMMENT_NOT_PERFECT,
        value: 'Result not optimal',
    },
    {
        id: QUOTATION_COMMENT_PZR_REQUIRED,
        value: 'PZR required',
    },
    {
        id: QUOTATION_COMMENT_PZR_RECOMMENDED,
        value: 'PZR recommended',
    },
    {
        id: QUOTATION_COMMENT_DURATION_DIFFERS,
        value: 'Duration differs',
    },
]

export const QUOTATION_COMMENT_TEXT = {
    [QUOTATION_COMMENT_NOT_PERFECT]: localizedText({
        DE:
            'Ihr Behandlungsplan zeigt das mit PlusDental Zahnschienen erreichbare optimale Ergebnis. Gerne besprechen wir Ihre Behandlung mit Ihnen im persönlichen Expertengespräch- buchen Sie sich einfach in der entsprechenden Auswahl unter Ihrem Behandlungsplan einen Termin.',

        GB:
            'Your treatment plan shows the optimal result which can be achieved with PlusDent aligners. We are go through your treatment plan with you and one of our experts- simply book a phone call with our Expert-team right below your treatment plan.',

        NL:
            'Uw behandelplan toont het optimale resultaat dat kan worden bereikt met Plus Dental aligners. We nemen uw behandelplan met u en een van onze experts door - boek eenvoudig een telefoongesprek met ons Expert-team onder uw behandelplan.',

        SE:
            'Din behandlingsplan visar det optimala resultatet som kan uppnås med PlusDentals tandskenor. Vi går gärna igenom din behandlingsplan med dig och en av våra experter - boka helt enkelt ett telefonsamtal med vårt Expert-team direkt under din behandlingsplan.',
    }),
    [QUOTATION_COMMENT_PZR_REQUIRED]: localizedText({
        DE:
            'Bei Ihnen wurde eine Entzündung und/oder Zahnstein diagnostiziert. Daher ist eine professionelle Zahnreinigung vor Einsetzen der ersten Zahnschienen unbedingt notwendig. Dies dient sowohl Ihrer Mundgesundheit, als auch dem Behandlungsergebnis. Erfolgt die Zahnreinigung vor Einsetzen der Zahnschienen nicht, beeinträchtigt es die Passgenauigkeit der Zahnschienen und so kann das errechnete Behandlungsergebnis nicht garantiert werden.',

        GB:
            'Prior to your treatment beginning you should have a professional teeth cleaning done with your dentist. This is a prerequisite for fitting your aligners and to achieve your optimal treatment results.',

        NL:
            'Voordat uw behandeling begint, moet u een professionele gebitsreiniging laten uitvoeren door uw tandarts. Dit is een voorwaarde voor het passen van uw aligners en voor het bereiken van uw optimale behandelresultaten.',

        SE:
            'En professionell tandrengöring är nödvändig innan du börjar använda dina tandskenor. Det gynnar både resultatet av din behandling såväl som din tandhälsa. Om du inte rengör tänderna ordentligt innan du använder skenorna kan det påverka hur skenorna sitter på tänderna och det optimala behandlingsresultatet kan därmed inte garanteras.',
    }),
    [QUOTATION_COMMENT_PZR_RECOMMENDED]: localizedText({
        DE:
            'Bitte lassen Sie eine professionelle Zahnreinigung vor Einsetzen der ersten Schienen bei Ihrem Hauszahnarzt durchführen. Danach sind Sie startklar für die Zahnschienenbehandlung.',

        GB:
            "We'd recommend to have a professional teeth cleaning done prior to your treatment with PlusDent aligners. Good dental hygiene ensures that you achieve an optimal treatment result.",

        NL:
            'We raden u aan om een professionele gebitsreiniging te ondergaan, voordat u de behandeling start bij. Een goede gebitshygiëne zorgt ervoor dat u een optimaal behandelresultaat behaalt.',

        SE:
            'Vi rekommenderar att din tandläkare utför en professionell tandrengöring innan du börjar använda dina tandskenor. Detta kommer att gynna både din tandhälsa såväl som resultatet av behandlingen.',
    }),
    [QUOTATION_COMMENT_DURATION_DIFFERS]: localizedText({
        DE:
            'Ihre Behandlung zeigt eine unterschiedliche Schienenanzahl pro Kiefer auf. Bitte tragen Sie die letzte Zahnschiene, der kürzeren Behandlung, insgesamt vier Wochen (statt nur zwei Wochen) und danach nur noch nachts. In Ihrem anderem Kiefer führen Sie bitte Ihre Behandlung regulär weiter und wechseln, wie in Ihrem Behandlungsplan vorgesehen, die Zahnschienen aus.',

        GB:
            'Your treatment shows a different number of aligners per jaw. Please wear the last set of aligners for the jaw with the shorter treatment period for four weeks (instead of just two) and then switch to wearing them at night only. For the other jaw you should continue to wear and switch the aligner sets as prescribed until you have finished the treatment.',

        NL:
            'Uw behandeling toont een verschillend aantal aligners per kaak. Draag de laatste set aligners voor de kaak met de kortere behandelperiode gedurende vier weken (in plaats van twee) en wacht tot de nacht retainer binnen is of anders bestel deze. Zodra deze ontvangen is kunt u hierop overstappen. Voor de andere kaak moet u de alignersets blijven dragen en wisselen zoals voorgeschreven totdat u klaar bent met de behandeling.',

        SE:
            'Din behandling visar olika antal tandskenor per käke. Bär den sista skenan för käken med den kortare behandlingsperioden i fyra veckor (i stället för bara två) och övergå sedan till att bara bära dem på natten. För den andra käken ska du fortsätta att bära och byta skenor enligt instruktionerna tills du har avslutat behandlingen.',
    }),
    [QUOTATION_COMMENT_PRETREATMENT]: localizedText({
        DE:
            'Bei dem Besuch in unserer Praxis haben wir festgestellt, dass eine Vorbehandlung notwendig ist. Bitte tragen Sie die Zahnschienen erst, wenn Sie die Vorbehandlung abgeschlossen haben.',

        GB:
            'During the visit in our practice, we discovered that a pretreatment is necessary. Please do not wear the aligners until you have completed the pre-treatment.',

        ES:
            'Durante la visita a nuestra clínica dental, descubrimos si es necesario un pretratamiento. Por favor, no use los alineadores hasta que haya completado el pretratamiento.',
    }),
}

export const PACKAGESIZE_VALUES = [
    {
        id: PACKAGESIZE_LIGHT,
        value: 'Leicht',
    },
    {
        id: PACKAGESIZE_MEDIUM,
        value: 'Medium',
    },
    {
        id: PACKAGESIZE_COMPLEX,
        value: 'Complex',
    },
]

export const PRETREATMENT_NEEDED_VALUES = [
    {
        id: false,
        value: 'No Pretreatment required',
    },
    {
        id: true,
        value: 'Pretreatment required',
    },
]

export const ATTACHMENT_VALUES = [
    {
        id: true,
        value: 'Attachment Needed',
    },
    {
        id: false,
        value: 'Attachment Not Needed',
    },
]

export const ALIGNER_SYSTEM_LIST_FULL = [
    {
        id: '2-2',
        value: '2-2',
    },
    {
        id: '1-1-2',
        value: '1-1-2',
    },
]

export const ALIGNER_SYSTEM_DEFAULT_VALUE = '2-2'

export const ALIGNER_SYSTEM_LIST_HAT_GROUP = [
    {
        id: '2-2',
        value: '2-2',
    },
]

export const ALIGNER_SYSTEM_ALIGNERS_PER_STEP = {
    '1-1-2': 3,
    '2-2': 2,
}



// WEBPACK FOOTER //
// ./src/modules/treatment/state/quotation/const.js